(function($){
	window._bilingualTheme.bilingualElements = []
	window.Bilingual = function(){
		$(function() {

			var langAttributes = $('.lang-attr'),
				langSelect = $('.lang-select');

			if( ! _bilingualTheme.settings.use_lang2 ) {
				$('.lang-select').remove();
				eraseCookie("sn-multiling");
			}

			langSelect.show();
			setUpBilingualElements();
			setStartLanguage();

			langSelect.on('click', 'span', function(){
				currentLang = switchLang($(this).data('lang'));
			});


			function switchLang(lang){
				var lang;

				if( _bilingualTheme.settings.primary_language == "1" ) {
					lang = lang == null ? "lang1" : lang;
				}else {
					lang = lang == null ? "lang2" : lang;
				}
				$('.language-link').removeClass('language-on');
				$('span[data-lang="' + lang + '"]').addClass('language-on');

				languages = $('.lang'),
				newLang = $('.' + lang);

				languages.hide();
				newLang.show();

				// check for display style
				$.each(newLang, function(i, obj) {
					obj = $(obj);

					if(obj.hasClass('inline-block')){
						obj.css('display', 'inline-block');
					}else{
						obj.css('display', 'block');
					}
				});

				$.each(window._bilingualTheme.bilingualElements, function(i, obj){
					var elem = obj.elem;

					if(obj.attr != "text"){
						if( obj[lang] != "" ){
							elem.attr(obj.attr, obj[lang]);
						}
					}else{
						var text = "";

						if(obj[lang] != ""){
							text = obj[lang];

							if (elem.data('price') ){
								text += " - " + elem.data('price');
							};

						}else{
							text = elem.text();
						}

						if(text != ""){
							elem.text(text);
						}
					}
				});

				var title = "";

				if( _bilingualTheme.template == "index" ) {
					title = _bilingualTheme.shopName;
				}else {
					var tabTitle = $('.tab-title');

					if(tabTitle.find('.lang').length > 0){
						title = $('.tab-title .' + lang).first().text();
					}else{
						title = tabTitle.text();
					}
				}

				if(title != _bilingualTheme.shopName){
					title += " | " + _bilingualTheme.shopName;
				}

				setTitle(title);

				createCookie("sn-multiling", lang, 1);

				return lang;
			}

			function setTitle(newTitle){
				window.document.title = newTitle;
			}

			function setStartLanguage(){
				var lang = readCookie("sn-multiling");

				switchLang(lang);

			}

			function createCookie(name,value,days) {
				if (days) {
					var date = new Date();
					date.setTime(date.getTime()+(days*24*60*60*1000));
					var expires = "; expires="+date.toGMTString();
				}
				else {
					var expires = "";
				}

				document.cookie = name+"="+value+expires+"; path=/";
			}

			function readCookie(name) {
				var nameEQ = name + "=";
				var ca = document.cookie.split(';');
				for(var i=0;i < ca.length;i++) {
					var c = ca[i];
					while (c.charAt(0)==' ') c = c.substring(1,c.length);
					if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
				}
				return null;
			}

			function eraseCookie(name) {
				createCookie(name,"",-1);
			}

			function setUpBilingualElements(){
				var isProductTemplate = _bilingualTheme.template.indexOf('product') == -1 ? false : true;

				$.each(langAttributes, function(i, obj){
					obj = $(obj);
					attr = obj.data('attr');

					if( obj.length != 0 ){
						var bilingualText = obj.data('bilingual').toString(),
	                        pipePos = bilingualText.indexOf('|'),
							lang1 = bilingualText.substring( 0, pipePos ),
							lang2 = bilingualText.substring( pipePos + 1, obj.data('bilingual').length );

						window._bilingualTheme.bilingualElements.push({
							elem: obj,
							attr: attr,
							lang1: lang1,
							lang2: lang2
						});
					}
				});

				if( isProductTemplate ) {
					// for multiple variants and options
					var selectors = $('.selector-wrapper');

					$.each(selectors, function(i, obj){
						var $obj = $(obj),
							label = $obj.find('label'),
							options = $obj.find('option');

						// labels
						var labelText = label.text().toString(),
							pipePos = labelText.indexOf('|');

						if(pipePos != -1 ){
							var lang1 = labelText.substring( 0, pipePos ),
								lang2 = labelText.substring( pipePos + 1, labelText.length );

							label.text("");

							$('<span></span>', {
								class: "lang lang1",
								text: lang1
							}).appendTo(label);

							$('<span></span>', {
								class: "lang lang2",
								text: lang2
							}).appendTo(label);
						}

						// options
						$.each(options, function(i, obj){
							var $obj = $(obj),
								text = $obj.val().toString(),
								pipePos = text.indexOf('|'),
								lang1 = text.substring( 0, pipePos ),
								lang2 = text.substring( pipePos + 1, text.length ),
								sameIndex;

							lang1 = lang1 == "" ? lang2 : lang1;

							$.each(window._bilingualTheme.bilingualElements, function(i, item){
								var currentText = obj.nodeName + " " + $obj.text(),
									testText = item.elem[0].nodeName + " " + item.elem.text();

								if( currentText == testText ){
									sameIndex = i;
								}
							});

							// replace the existing one with the new one if it exists
							window._bilingualTheme.bilingualElements.push({
								elem: $obj,
								attr: 'text',
								lang1: lang1,
								lang2: lang2
							});
						});
					});
				}

				// Clean up elements with only one language
				var languages = $('.lang1');

				// Find all lang1 elements. If the next element doesn't have the lang2 class, the translation is missing, so remove the language classes from the object.
				$.each(languages, function(i, obj){
					if( ! $(obj).next().hasClass('lang') )
						$(obj).removeClass('lang lang1');
				});
			}
		});
	}

	Bilingual();

})(jQuery);